import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Button } from 'antd';
import {
  EmailComponentsCardProps,
  ReferencedBy
} from '../../../../models/emailComponents';
import TemplateManipulate from '../../../common/templateManipulate';
import { Components } from '../../../common/componentsEnum';
import axiosConfig from '../../../../utils/axiosConfig';
import { Redirect, useParams } from 'react-router-dom';

const EmailComponents: React.FC<EmailComponentsCardProps> = ({
  component,
  fetchTemplates,
  changeLoadingState
}) => {
  const { accountId } = useParams<{ accountId: string }>();
  const [selectedTemplate, setSelectedTemplate] = useState<ReferencedBy>();
  const [redirectPath, setChangeRedirectPath] = useState<string>();
  const [cardLoading, setCardLoading] = useState(false);

  const handleDelete = () => {
    axiosConfig(
      'delete',
      `/${accountId}/components/EMAIL/${component.componentId}`,
      {},
      () => {
        fetchTemplates();
      }
    );
  };

  useEffect(() => {
    if (selectedTemplate) {
      axiosConfig(
        'get',
        `/${accountId}/notifications/${selectedTemplate.notificationId}`,
        {},
        () => {
          setChangeRedirectPath(
            `/${accountId}/notifications/${selectedTemplate.notificationId}/beeEditor/${selectedTemplate.templateId}`
          );
        }
      );
    }
  }, [selectedTemplate, accountId]);

  return redirectPath ? (
    <Redirect to={redirectPath} />
  ) : (
    <Card
      loading={cardLoading}
      data-cy={component.name}
      style={{
        marginBottom: '12px',
        minHeight: '150px'
      }}
      title={component.name}
    >
      {component.referencedBy.length > 0 ? (
        <>
          <Row> {`${component.name} email component is used at: `}</Row>
          <Row key={'dataCard'} style={{ justifyContent: 'space-between' }}>
            <Col span={22}>
              {component.referencedBy.map((e: ReferencedBy, index) => {
                return (
                  <Row
                    key={index}
                    style={{
                      margin: '12px'
                    }}
                  >
                    <Button
                      style={{ width: '50%' }}
                      onClick={(): void => {
                        setSelectedTemplate(e);
                      }}
                    >
                      {[
                        'Notification ID: ',
                        <b key={'NotificationID'}>{` ${e.notificationId}`}</b>,
                        '   - Template ID: ',
                        <b key={'TemplateID'}>{` ${e.templateId}`}</b>
                      ]}
                    </Button>
                  </Row>
                );
              })}
            </Col>
            <Col span={2}>
              <TemplateManipulate
                onCopy={fetchTemplates}
                onDelete={handleDelete}
                editPath={`/${accountId}/beeEditor/${component.componentId}/componentName/${component.name}`}
                cardType={Components.EMAIL}
                template={component}
                changeLoadingState={changeLoadingState}
                setCardLoading={setCardLoading}
              />
            </Col>
          </Row>
        </>
      ) : (
        <Row>
          <Col span={22}>
            {`${component.name} email component is not used anywhere.`}
          </Col>
          <Col span={2}>
            <TemplateManipulate
              onCopy={fetchTemplates}
              onDelete={handleDelete}
              editPath={`/${accountId}/beeEditor/${component.componentId}/componentName/${component.name}`}
              cardType={Components.EMAIL}
              template={component}
              changeLoadingState={changeLoadingState}
              setCardLoading={setCardLoading}
            />
          </Col>
        </Row>
      )}
    </Card>
  );
};

export default EmailComponents;
